/* 閲覧履歴（最近チェックしたアイテム）2026-10-13
   出す場所：
   - ハンバーガーメニューの上部 [data-vm-recent-nav]（sections/sp-nav.liquid）… 写真 4 件
   - 商品ページの「RECENTLY VIEWED」の枠 [data-vm-recent-section]（sections/recently-viewed.liquid）… テーマエディタの件数
   しくみ：
   - 履歴は theme.js が商品ページを開くたびに localStorage の 'theme-recent' に足しているもの（handle ごと・古い順）。
   - 各商品は /products/<handle>?sections=vm-recent-item で 1 件ずつ取る（今の言語・価格・在庫の表示で出すため、
     履歴に保存された URL や写真は使わない）。
   - 見つからない商品（削除・非公開・下書き＝404）と一覧非表示の商品は飛ばし、履歴からも消す。
     足りない分は新しい順に次の商品で埋める。1 件も出せなければ枠ごと出さない。
   - 今見ている商品は出さない。 */
(function () {
  'use strict';

  var STORAGE_KEY = 'theme-recent';
  var SECTION_ID = 'vm-recent-item';
  var EXTRA = 2;                 // 消えている商品の分を見込んで、表示件数より多めに確かめる数
  var MAX_CHECK = 20;            // 1 ページで確かめる商品の上限
  var CACHE_KEY = 'vm-recent-items';
  var CACHE_MS = 10 * 60 * 1000; // 取った 1 商品分をこのタブで使い回す時間

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var pending = {};              // handle -> Promise（同じページで同じ商品を二度取らない）

  function readHistory() {
    try {
      var data = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
      return data && typeof data === 'object' ? data : {};
    } catch (e) {
      return {};
    }
  }

  // 履歴から外す。theme.js がページを開いたときに読み込んだ控えからも消す
  // （残すと、theme.js が履歴を書き戻したときに復活する）
  function forget(handle) {
    try {
      var recent = window.theme && window.theme.recentlyViewed && window.theme.recentlyViewed.recent;
      if (recent) delete recent[handle];
      var data = readHistory();
      if (Object.prototype.hasOwnProperty.call(data, handle)) {
        delete data[handle];
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      }
    } catch (e) { /* ストレージが使えないときは何もしない */ }
  }

  function currentHandle() {
    var el = document.querySelector('.product-section[data-history="true"][data-product-handle]');
    return el ? el.getAttribute('data-product-handle') : null;
  }

  // 新しい順の handle（今見ている商品を除く）
  function candidates() {
    var current = currentHandle();
    return Object.keys(readHistory()).reverse().filter(function (handle) {
      return handle && handle !== 'undefined' && handle !== current;
    });
  }

  // --- 取った HTML の控え（このタブだけ・言語ごと） ---
  function readCache() {
    try {
      return JSON.parse(window.sessionStorage.getItem(CACHE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }
  function getCached(handle) {
    var hit = readCache()[root + handle];
    return hit && Date.now() - hit.t < CACHE_MS ? hit.html : null;
  }
  function putCache(handle, html) {
    var cache = readCache();
    var now = Date.now();
    Object.keys(cache).forEach(function (key) {
      if (now - cache[key].t >= CACHE_MS) delete cache[key];
    });
    cache[root + handle] = { t: now, html: html };
    try {
      window.sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache));
    } catch (e) { /* 容量超過などは控えなしで続ける */ }
  }

  // 1 商品分の HTML を読む。<template> に入れるので、ページに入れるまで写真は読み込まれない。
  // 出せない商品は item が null・gone が true（商品が無い＝削除・非公開・下書き／一覧非表示）
  function parseItem(html) {
    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    var item = tpl.content.querySelector('[data-vm-recent-item]');
    // 商品が無いとき、この取り方では 404 ではなく 200 で中身が空のセクションが返る（2026-10-13 実測）
    if (!item) return { item: null, gone: true };
    if (!item.querySelector('[data-vm-recent-card] .grid-product')) return { item: null, gone: true }; // 一覧非表示
    return { item: item, gone: false };
  }

  // 1 商品分を取る。出せない商品は null
  function fetchItem(handle) {
    if (pending[handle]) return pending[handle];
    var cached = getCached(handle);
    if (cached) {
      pending[handle] = Promise.resolve(parseItem(cached).item);
      return pending[handle];
    }
    var url = root + 'products/' + encodeURIComponent(handle) + '?sections=' + SECTION_ID;
    // Accept: application/json を付けると ?sections= が無視され、商品そのものの JSON が返るので付けない
    pending[handle] = fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (res.status === 404) { // 念のため（今は 200 で空のセクションが返る）
          forget(handle);
          return null;
        }
        if (!res.ok) return null; // 一時的なエラー（429・5xx など）は履歴に残したまま飛ばす
        return res.json().then(function (json) {
          var html = json && json[SECTION_ID];
          if (!html) return null;   // セクションが取れなかった（エラー）。履歴は残す
          var parsed = parseItem(html);
          if (parsed.gone) forget(handle);
          if (parsed.item) putCache(handle, html);
          return parsed.item;
        });
      })
      .catch(function () {
        return null;
      });
    return pending[handle];
  }

  // 新しい順に、表示件数がそろうまで確かめる（同じ商品が別の handle で残っていても 1 回だけ出す）
  function collect(limit) {
    var list = candidates().slice(0, MAX_CHECK);
    var found = [];
    var seen = {};
    var pos = 0;
    function next() {
      if (found.length >= limit || pos >= list.length) return Promise.resolve(found);
      var batch = list.slice(pos, pos + limit - found.length + EXTRA);
      pos += batch.length;
      return Promise.all(batch.map(fetchItem)).then(function (items) {
        items.forEach(function (item) {
          if (!item || found.length >= limit) return;
          var id = item.getAttribute('data-vm-recent-id');
          if (seen[id]) return;
          seen[id] = true;
          found.push(item);
        });
        return next();
      });
    }
    return next();
  }

  // --- 商品ページの枠 ---
  function renderSection(el) {
    var limit = parseInt(el.getAttribute('data-recent-count'), 10) || 5;
    var grid = el.querySelector('[data-vm-recent-grid]');
    collect(limit).then(function (items) {
      grid.innerHTML = '';
      if (!items.length) {
        el.hidden = true;
        return;
      }
      items.forEach(function (item) {
        grid.appendChild(document.importNode(item.querySelector('[data-vm-recent-card] .grid-product'), true));
      });
      el.hidden = false;
      if (window.theme && typeof window.theme.reinitProductGridItem === 'function') {
        window.theme.reinitProductGridItem(el);
      }
    });
  }

  function setupSection(el) {
    if (!candidates().length) return;
    if (!('IntersectionObserver' in window)) {
      renderSection(el);
      return;
    }
    // 枠は隠してあるので、外側のセクション（高さ 0）が画面の 600px 手前まで来たら取りに行く
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) {
        io.disconnect();
        renderSection(el);
      }
    }, { rootMargin: '0px 0px 600px 0px' });
    io.observe(el.parentElement || el);
  }

  // --- ハンバーガーメニュー ---
  function setupNav(nav) {
    var list = nav.querySelector('[data-vm-recent-nav-list]');
    var limit = parseInt(nav.getAttribute('data-recent-count'), 10) || 4;
    var count = Math.min(candidates().length, limit);
    if (!count) return;

    // 開いた後で下のメニューがずれないよう、先に 1 段分の場所を取っておく
    var slots = '';
    for (var i = 0; i < count; i++) {
      slots += '<li class="vm-recent-nav__item"><span class="vm-recent-nav__item--loading"></span></li>';
    }
    list.innerHTML = slots;
    nav.hidden = false;

    var started = false;
    function load() {
      if (started) return;
      started = true;
      collect(limit).then(function (items) {
        list.innerHTML = '';
        if (!items.length) {
          nav.hidden = true;
          return;
        }
        items.forEach(function (item) {
          var li = document.createElement('li');
          li.className = 'vm-recent-nav__item';
          li.appendChild(document.importNode(item.querySelector('[data-vm-recent-mini]'), true));
          list.appendChild(li);
        });
      });
    }

    // メニューのボタンに触れた時点で取りに行く（開くのと同時に並ぶように）
    var toggle = document.querySelector('.header__icons__toggle');
    if (toggle) {
      ['pointerenter', 'pointerdown', 'touchstart', 'focus', 'click'].forEach(function (type) {
        toggle.addEventListener(type, load, { passive: true });
      });
    }
    if (document.querySelector('.sp-nav.js-open')) load();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vm-recent-nav]'), setupNav);
    Array.prototype.forEach.call(document.querySelectorAll('[data-vm-recent-section]'), setupSection);
  }

  // テーマエディタでセクションを描き直したとき
  document.addEventListener('shopify:section:load', function (event) {
    Array.prototype.forEach.call(event.target.querySelectorAll('[data-vm-recent-section]'), setupSection);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
